import api from './index'

export default {
    async bulkDeposit(body) {
        const response = await api.post('/deposits/bulk', body)
        return response.data
    },
    async bulkDepositSimulate(body) {
        const response = await api.post('/deposits/bulk?simulate=true', body)
        return response.data
    },
    async finalize() {
        const response = await api.post('/deposits/finalize')
        return response.data
    },
    async getDepositStatus(depositId) {
        if (!depositId) {
            throw new Error('deposit id is required')
        }
        const response = await api.get(`/deposits/${depositId}/status`)
        return response.data
    },
}
